import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var SimpleMapCoord = /*#__PURE__*/function () {
  function SimpleMapCoord(size) {
    _classCallCheck(this, SimpleMapCoord);

    _defineProperty(this, "size", 10000);

    this.size = size ? size : 10000;
  }

  _createClass(SimpleMapCoord, [{
    key: "setSize",
    value: function setSize(size) {
      this.size = size;
    }
  }, {
    key: "getSize",
    value: function getSize() {
      return [this.size, this.size];
    }
    /**
     * coord
     * ^ y (y > 0)
     * |
     * |
     * |
     * |(x = 0, y = 0)
     * ---------------> x (x > 0)
     */

    /***
     * lng: [-180, 180] 360
     * lat: [-85.05112877980659, 85.05112877980659] 170.10225755961318
     */

  }, {
    key: "mercatorXfromLng",
    value: function mercatorXfromLng(lng) {
      // (0 - 1) * this.size
      return (180 + lng) / 360 * this.size;
    }
  }, {
    key: "mercatorYfromLat",
    value: function mercatorYfromLat(lat) {
      // (0 - 1) * this.size
      return (1 - (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360))) / 360) * this.size;
    }
  }, {
    key: "lngFromMercatorX",
    value: function lngFromMercatorX(x) {
      return x / this.size * 360 - 180;
    }
  }, {
    key: "latFromMercatorY",
    value: function latFromMercatorY(y) {
      var y2 = 180 - (1 - y / this.size) * 360;
      return 360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90;
    }
  }, {
    key: "project",
    value: function project(lnglat) {
      var x = this.mercatorXfromLng(lnglat[0]);
      var y = this.mercatorYfromLat(lnglat[1]);
      return [x, y];
    }
  }, {
    key: "unproject",
    value: function unproject(xy) {
      var lng = this.lngFromMercatorX(xy[0]);
      var lat = this.latFromMercatorY(xy[1]);
      return [lng, lat];
    }
  }]);

  return SimpleMapCoord;
}();